module.exports = __webpack_public_path__ + "static/img/c6426dd09d91daf153b9dbdb521595cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer.jpg
// module id = v5Mo
// module chunks = 1